import React, { useState, useEffect, useRef } from "react";
import Navbar from '../Components/Navbar'
import confetti from "canvas-confetti";
import { isMobile } from "react-device-detect";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';
import SmartAi from "../Components/SmartAi";
import Footer from "../Components/Footer";
import Core from "../Components/Core";
import Pictures from "../Components/Pictures";
import { Link } from "react-router-dom";

const Home = () => {

    const swiperRef = useRef(null);

    const [activeIndex, setActiveIndex] = useState(1);

    // Example dynamic data
    const events = [
        {
          title: "Graduation Ceremony",
          description:
            "A day of joy and pride as we celebrate the achievements of our graduating students. Families, friends, and staff gather to honor their journey, reflect on their growth, and send them forth with blessings into the next stage of life.",
        },
        {
          title: "Sports Festival",
          description:
            "An energetic day filled with athletics, teamwork, and healthy competition. From track and field to group games, students showcase their sporting skills while learning discipline, endurance, and the spirit of fair play.",
        },
        {
          title: "Cultural Day",
          description:
            "A vibrant celebration of our nation’s diversity and traditions. Students dress in colorful cultural attire, present dances, songs, drama, and display foods from different ethnic groups — promoting unity and appreciation for our shared heritage.",
        },
        {
          title: "Science Fair",
          description:
            "A platform for young innovators to shine. Students present experiments, inventions, and scientific discoveries that inspire curiosity, problem-solving, and creativity while fostering a love for science and technology.",
        },
        {
          title: "Indomie Fan Club Day",
          description:
            "An exciting, fun-filled gathering where students come together to enjoy activities sponsored by the Indomie Fan Club. Packed with games, singing, dancing, and of course delicious Indomie noodles, it’s always a highlight for the children.",
        },
        {
          title: "Family Trivia Game",
          description:
            "A lively family-bonding activity where parents, students, and teachers team up to answer fun, educational, and general knowledge questions. It’s all about teamwork, laughter, and learning in a relaxed atmosphere.",
        },
        {
          title: "Inter-House Sports",
          description:
            "One of the most anticipated events of the year! Students compete in various athletic activities representing their houses. The energy, cheers, and vibrant colors create an atmosphere of unity, rivalry, and school spirit.",
        },
        {
          title: "Inter-Quiz Competition",
          description:
            "A thrilling intellectual challenge where students from different houses or classes compete in subjects ranging from Mathematics and Science to Literature and General Knowledge. It builds confidence, sharpens the mind, and fosters academic excellence.",
        },
    ];

    // Example for testimonials
    const testimonials = [
        {
            name: "Mr Abollo",
            role: "Parent",
            feedback: "Ebun Heritage Schools has been a transformative experience for my child. The nurturing environment and dedicated staff have helped her thrive academically and personally.",
            avatar: "../../assets/images/background/parent/1.jpg",
        },
    ];
      
    // function to style card based on its index relative to the activeIndex
    const getCardStyle = (index) => {
        if (index === activeIndex) {
        return {
            width: "250px",
            marginBottom: "50px",
            transitionDuration: "300ms",
            transform: "translate3d(0px, 0px, 0px) scale(1)",
            zIndex: 2,
            borderRadius: "8px",
            boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
        };
        } else if (index === activeIndex - 1 || (activeIndex === 0 && index === events.length - 1)) {
        // left card
        return {
            width: "250px",
            transitionDuration: "300ms",
            transform: "translate3d(0px, 0px, -100px) scale(0.9)",
            zIndex: 0,
            borderRadius: "8px",
            boxShadow: "none",
            opacity: 0.9,
        };
        } else if (index === activeIndex + 1 || (activeIndex === events.length - 1 && index === 0)) {
        // right card
        return {
            width: "250px",
            transitionDuration: "300ms",
            transform: isMobile ? "translate3d(80px, 0px, -100px) scale(0.9)" : "translate3d(0px, 0px, -100px) scale(0.9)",
            zIndex: 0,
            borderRadius: "8px",
            boxShadow: "none",
            opacity: 0.8,
        };
        } else {
        // all other slides
        return {
            width: "250px",
            transitionDuration: "300ms",
            transform: "scale(0.8)",
            opacity: 0.5,
            zIndex: -1,
            borderRadius: "8px",
            boxShadow: "none",
        };
        }
    };

    useEffect(() => {
        GLightbox({ selector: '.glightbox' });
    }, []);
      

    const media = [
        "../../assets/images/background/slide/head2.jpg",
        "../../assets/images/background/slide/18.jpg",
        "../../assets/images/background/slide5.jpeg",
        "../../assets/images/background/ebun5.jpg",
        "../../assets/images/background/slide/3.jpg",
        "../../assets/images/background/n3.mp4",
        "../../assets/images/background/n2.jpg",
        "../../assets/images/background/n1.jpg",
        "../../assets/images/background/2.jpg",
        "../../assets/images/background/1.jpg",
        "../../assets/images/background/slide1.jpeg",
        "../../assets/images/background/slide2.jpeg",
        "../../assets/images/background/slide3.jpeg",
        "../../assets/images/background/slide4.jpeg",
    ];

    const fireConfetti = () => {
        const duration = 10 * 1000; // 10 seconds
        const end = Date.now() + duration;
    
        (function frame() {
          confetti({
            particleCount: 8,
            spread: 90,
            origin: { y: 0.6 },
          });
    
          if (Date.now() < end) {
            requestAnimationFrame(frame);
          }
        })();
      };
    
      useEffect(() => {
        fireConfetti(); // run once when page loads
      }, []);


  return (
    <>
    <Navbar />
    <main>

    <section
        className="py-xl-0 py-0 position-relative"
        style={isMobile ? { } : {
            backgroundImage: "url('../../assets/images/background/back.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
        }}
    >
        

        <div className="container px-0 px-lg-4 py-lg-12 py-0 position-relative" style={{ zIndex: 2 }}>
            <div className="d-lg-flex gap-0 align-items-stretch py-lg-6">
            
            {/* Left Card */}
            <div className="col-lg-6 d-flex">
                <div
                    className="card bg-light-blue px-lg-8 py-lg-8 py-4 px-5 text-center w-100 h-100 text-dark"
                    style={isMobile ? {borderRadius: "0px"} : {
                        borderTopLeftRadius: "30px",
                        borderBottomLeftRadius: "30px",
                    }}
                    >
                    <div className="mb-4 mb-lg-4">
                        <hr
                        className="text-primary"
                        style={{
                            width: "70px",
                            border: "3px solid #fff",
                        }}
                        />
                    </div>

                    <div className="mb-2 fs-4 fw-medium text-dark">
                        Celebrating 25 Years of Excellence!
                    </div>

                    <div className="mb-4 fs-t2 fw-medium">
                        Ebun Heritage Schools — Where Excellence Meets Purpose!
                    </div>

                    <div className="mb-6 mb-lg-6 fs-4 text-center text-lg-start">
                        For 25 years, Ebun Heritage has nurtured leaders with wisdom,
                        discipline, and excellence. 🌟 Beyond academics, we shape character,
                        creativity, and values for a brighter future. 💡👩‍🎓👨‍🎓 ✨ Ebun Heritage
                        Schools — Building Brilliance, Shaping Futures. ✨
                    </div>

                    <div className="d-flex justify-content-center justify-content-lg-start mb-4 mb-lg-0">
                        <Link to="/admission" className="btn btn-outline-light rounded-pill">
                        Apply Now <i className="bi bi-arrow-right"></i>
                        </Link>    
                    </div>
                </div>
            </div>

            {/* Right Image */}
            <div className="col-lg-6 d-flex">
                <div
                    className="card bg-transparent w-100 h-100 overflow-hidden position-relative border-0"
                    style={
                    isMobile
                        ? { borderRadius: "0px" }
                        : {
                            borderTopRightRadius: "30px",
                            borderBottomRightRadius: "30px",
                        }
                    }
                >
                    {/* Image */}
                    <Swiper
                    modules={[Autoplay]}
                    pagination={{ clickable: true }}
                    navigation
                    autoplay={{ delay: 3000, disableOnInteraction: false }}
                    loop={true}
                    className="w-100 h-100"
                    >
                    {media.map((src, index) => (
                        <SwiperSlide key={index}>
                        {src.endsWith(".mp4") ? (
                            <video
                            className="w-100 h-100 object-fit-cover"
                            autoPlay
                            muted
                            loop
                            playsInline
                            >
                            <source src={src} type="video/mp4" />
                            Your browser does not support the video tag.
                            </video>
                        ) : (
                            <img
                            src={src}
                            alt={`slide-${index}`}
                            className="w-100 h-100 object-fit-cover"
                            />
                        )}
                        </SwiperSlide>
                    ))}
                    </Swiper>
                </div>
            </div>

        </div>
        </div>
    </section>

    <section className="py-0 bg-white">

        <div className="container position-relative" style={{ zIndex: 2 }}>
            <div className="text-center mb-6 mt-6">
                <div className="fs-2 fw-semibold mb-2">
                <span className="text-success">
                <svg width="35" height="35" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-[#FF884D]"><path d="m13.733 1.223.579 1.627a1.84 1.84 0 0 0 2.523 1.045l1.56-.741c1.563-.743 3.194.888 2.451 2.451l-.741 1.56a1.838 1.838 0 0 0 1.045 2.523l1.627.578c1.63.58 1.63 2.886 0 3.467l-1.627.579a1.84 1.84 0 0 0-1.045 2.523l.741 1.56c.743 1.563-.888 3.194-2.451 2.451l-1.56-.741a1.839 1.839 0 0 0-2.523 1.044l-.579 1.628c-.58 1.63-2.886 1.63-3.466 0l-.579-1.628a1.84 1.84 0 0 0-2.523-1.044l-1.56.74c-1.563.744-3.194-.887-2.451-2.45l.741-1.56A1.84 1.84 0 0 0 2.85 14.31l-1.627-.578c-1.63-.58-1.63-2.887 0-3.467l1.627-.578a1.84 1.84 0 0 0 1.048-2.523l-.742-1.56c-.743-1.564.888-3.195 2.452-2.452l1.56.742A1.84 1.84 0 0 0 9.69 2.85l.578-1.627c.578-1.63 2.884-1.63 3.464 0Z" fill="currentColor"></path></svg>
                </span>
                <span className="text-dark">Watch Us</span> <u class="text-primary"><span className="text-gray-700"> Vibe.</span></u> 
                <span className="fs-4"> Click To Watch</span>
                </div>

                <p className="mb-0">
                    Discover the journey of Ebun Heritage Schools in our inaugural episode of Inspire Ebun.
                </p>
            </div>

            {/* ===== FIRST SECTION ===== */}
            <div className="row g-4">
            {/* Card 1 */}
            <div className="col-12 col-md-6 col-lg-4">
                <div
                className="card px-0 py-4 text-start border-0 bg-dark-blue h-100"
                style={{ borderRadius: "30px" }}
                >
                <div className="row align-items-center">
                    <div className="col-5 position-relative d-flex justify-content-center">
                    <img
                        src="../../assets/images/background/inspireebun.png"
                        alt="Inspire Ebun"
                        className="img-fluid rounded"
                        style={{ maxWidth: "80px" }}
                    />

                    <a
                        className="glightbox btn-play position-absolute top-50 start-50 translate-middle 
                        d-flex align-items-center justify-content-center"
                        href="https://youtu.be/7hcXcmNdX1I"
                        style={{
                        width: "40px",
                        height: "40px",
                        background: "#1dd1a1",
                        clipPath:
                            "polygon(50% 0%, 85% 15%, 100% 50%, 85% 85%, 50% 100%, 15% 85%, 0% 50%, 15% 15%)",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                        color: "#fff",
                        fontSize: "1rem",
                        textAlign: "center",
                        }}
                    >
                        <i className="fe fe-play"></i>
                    </a>
                    </div>

                    <div className="col-7 ms-n4">
                    <div className="fs-5 fw-semibold text-white mb-1">
                        Inspire Ebun Ep 1
                    </div>
                    <p className="mb-0 fs-6 text-white lh-sm">
                        Discover the journey of Ebun Heritage Schools in our inaugural
                        episode of Inspire Ebun.
                    </p>
                    </div>
                </div>
                </div>
            </div>

            {/* Card 2 */}
            <div className="col-12 col-md-6 col-lg-4">
                <div
                className="card px-0 py-4 text-start border-0 bg-dark-blue h-100"
                style={{ borderRadius: "30px" }}
                >
                <div className="row align-items-center">
                    <div className="col-5 position-relative d-flex justify-content-center">
                    <img
                        src="../../assets/images/background/inspireebun.png"
                        alt="Inspire Ebun"
                        className="img-fluid rounded"
                        style={{ maxWidth: "80px" }}
                    />
                    <a
                        className="glightbox btn-play position-absolute top-50 start-50 translate-middle 
                        d-flex align-items-center justify-content-center"
                        href="https://youtu.be/7hcXcmNdX1I"
                        style={{
                        width: "40px",
                        height: "40px",
                        background: "#1dd1a1",
                        clipPath:
                            "polygon(50% 0%, 85% 15%, 100% 50%, 85% 85%, 50% 100%, 15% 85%, 0% 50%, 15% 15%)",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                        color: "#fff",
                        fontSize: "1rem",
                        textAlign: "center",
                        }}
                    >
                        <i className="fe fe-play"></i>
                    </a>
                    </div>

                    <div className="col-7 ms-n4">
                    <div className="fs-5 fw-semibold text-white mb-1">
                        Inspire Ebun Ep 2
                    </div>
                    <p className="mb-0 fs-6 text-white lh-sm">
                        Discover the journey of Ebun Heritage Schools in our second
                        episode of Inspire Ebun.
                    </p>
                    </div>
                </div>
                </div>
            </div>

            {/* Card 3 */}
            <div className="col-12 col-md-6 col-lg-4">
                <div
                className="card px-0 py-4 text-start border-0 bg-dark-blue h-100"
                style={{ borderRadius: "30px" }}
                >
                <div className="row align-items-center">
                    <div className="col-5 position-relative d-flex justify-content-center">
                    <img
                        src="../../assets/images/background/inspireebun.png"
                        alt="Inspire Ebun"
                        className="img-fluid rounded"
                        style={{ maxWidth: "80px" }}
                    />
                    <a
                        className="glightbox btn-play position-absolute top-50 start-50 translate-middle 
                        d-flex align-items-center justify-content-center"
                        href="https://youtu.be/7hcXcmNdX1I"
                        style={{
                        width: "40px",
                        height: "40px",
                        background: "#1dd1a1",
                        clipPath:
                            "polygon(50% 0%, 85% 15%, 100% 50%, 85% 85%, 50% 100%, 15% 85%, 0% 50%, 15% 15%)",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                        color: "#fff",
                        fontSize: "1rem",
                        textAlign: "center",
                        }}
                    >
                        <i className="fe fe-play"></i>
                    </a>
                    </div>

                    <div className="col-7 ms-n4">
                    <div className="fs-5 fw-semibold text-white mb-1">
                        Inspire Ebun Ep 3
                    </div>
                    <p className="mb-0 fs-6 text-white lh-sm">
                        Discover the journey of Ebun Heritage Schools in our third
                        episode of Inspire Ebun.
                    </p>
                    </div>
                </div>
                </div>
            </div>
            </div>

            {/* ===== TITLE ===== */}
            <div className="mt-lg-9 mt-6 mb-3 text-center text-lg-start">
            <span className="fs-3 fw-medium">More Vibing....</span>
            </div>

            {/* ===== SECOND SECTION ===== */}
            <div className="row g-4">
            {/* Card 1 */}
            <div className="col-12 col-md-6 col-lg-4">
                <div
                className="card px-0 py-4 text-start border-0 bg-cream-white h-100"
                style={{ borderRadius: "30px" }}
                >
                <div className="row align-items-center">
                    <div className="col-5 position-relative d-flex justify-content-center">
                    <a
                        className="glightbox btn-play position-absolute top-50 start-50 translate-middle 
                        d-flex align-items-center justify-content-center"
                        href="https://youtu.be/7hcXcmNdX1I"
                        style={{
                        width: "40px",
                        height: "40px",
                        background: "#1dd1a1",
                        clipPath:
                            "polygon(50% 0%, 85% 15%, 100% 50%, 85% 85%, 50% 100%, 15% 85%, 0% 50%, 15% 15%)",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                        color: "#fff",
                        fontSize: "1rem",
                        textAlign: "center",
                        }}
                    >
                        <i className="fe fe-play"></i>
                    </a>
                    </div>

                    <div className="col-7 ms-n4">
                    <div className="fs-5 fw-semibold text-dark mb-1">
                        To Be or Not To Be Ep 1
                    </div>
                    <p className="mb-0 fs-6 text-dark lh-sm">
                        Get educated and entertained with our first episode of To Be or Not To Be.
                    </p>
                    </div>
                </div>
                </div>
            </div>

            {/* Card 2 */}
            <div className="col-12 col-md-6 col-lg-4">
                <div
                className="card px-0 py-4 text-start border-0 bg-cream-white h-100"
                style={{ borderRadius: "30px" }}
                >
                <div className="row align-items-center">
                    <div className="col-5 position-relative d-flex justify-content-center">
                    <a
                        className="glightbox btn-play position-absolute top-50 start-50 translate-middle 
                        d-flex align-items-center justify-content-center"
                        href="https://youtu.be/7hcXcmNdX1I"
                        style={{
                        width: "40px",
                        height: "40px",
                        background: "#1dd1a1",
                        clipPath:
                            "polygon(50% 0%, 85% 15%, 100% 50%, 85% 85%, 50% 100%, 15% 85%, 0% 50%, 15% 15%)",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                        color: "#fff",
                        fontSize: "1rem",
                        textAlign: "center",
                        }}
                    >
                        <i className="fe fe-play"></i>
                    </a>
                    </div>

                    <div className="col-7 ms-n4">
                    <div className="fs-5 fw-semibold text-dark mb-1">
                        To Be or Not To Be Ep 2
                    </div>
                    <p className="mb-0 fs-6 text-dark lh-sm">
                      Get informed and entertained with our second episode of To Be or Not To Be.
                    </p>
                    </div>
                </div>
                </div>
            </div>

            {/* Card 3 */}
            <div className="col-12 col-md-6 col-lg-4">
                <div
                className="card px-0 py-4 text-start border-0 bg-cream-white h-100"
                style={{ borderRadius: "30px" }}
                >
                <div className="row align-items-center">
                    <div className="col-5 position-relative d-flex justify-content-center">
                    <a
                        className="glightbox btn-play position-absolute top-50 start-50 translate-middle 
                        d-flex align-items-center justify-content-center"
                        href="https://youtu.be/7hcXcmNdX1I"
                        style={{
                        width: "40px",
                        height: "40px",
                        background: "#1dd1a1",
                        clipPath:
                            "polygon(50% 0%, 85% 15%, 100% 50%, 85% 85%, 50% 100%, 15% 85%, 0% 50%, 15% 15%)",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                        color: "#fff",
                        fontSize: "1rem",
                        textAlign: "center",
                        }}
                    >
                        <i className="fe fe-play"></i>
                    </a>
                    </div>

                    <div className="col-7 ms-n4">
                    <div className="fs-5 fw-semibold text-dark mb-1">
                        To Be or Not To Be Ep 3
                    </div>
                    <p className="mb-0 fs-6 text-dark lh-sm">
                      Get enlightened and entertained with our third episode of To Be or Not To Be.
                    </p>
                    </div>
                </div>
                </div>
            </div>
            </div>

        </div>

    </section>

    <section className="py-5 bg-white">
    <div className="container-fluid px-0">
        <div className="mt-3 pb-lg-0">
            <div className="fs-2 fw-semibold mb-2 text-center">
                Anniversary <u className="text-primary"><span className="text-dark">Celebration</span></u>
            </div>
            <p className="mb-6 text-center">
                Join us as we celebrate the rich history and bright future of Ebun Heritage Schools.
            </p>
            <Pictures />
        </div>
    </div>
    </section>

    <section className="pt-8 bg-light pb-8">
       <div className="container text-center mt-lg-n20">
          <div className="row justify-content-center">
            <div className="col-lg-6">
                <div
                className="card w-100 h-75 overflow-hidden border-0 position-relative"
                style={{ borderRadius: "50px 10px 50px 10px" }}
                >
                {/* Image */}
                <img
                    src="../../assets/images/background/director.jpg"
                    alt="Director"
                    width={600}
                    className="img-fluid"
                />

                {/* Play button */}
                <a
                    className="glightbox btn-play position-absolute top-50 start-50 translate-middle
                            d-flex align-items-center justify-content-center"
                    href="https://youtu.be/7hcXcmNdX1I"
                    data-type="video"
                    data-source="youtube"
                    style={{
                    width: "70px",
                    height: "70px",
                    background: "none",
                    clipPath:
                        "polygon(50% 0%, 85% 15%, 100% 50%, 85% 85%, 50% 100%, 15% 85%, 0% 50%, 15% 15%)",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                    color: "#fff",
                    fontSize: "2.5rem",
                    textAlign: "center",
                    }}
                >
                    <i className="fe fe-play"></i>
                </a>
                </div>
            </div>
            <div className="col-lg-6 mt-4 mt-lg-0">
                <div className="text-center text-lg-start px-0 px-lg-6">
                    <div className="fs-2 fw-semibold mb-2 text-gray-800">
                    
                        Director's <u class="text-primary"><span className="text-dark">Speech</span></u>
                    </div>      
                    <p className="mb-4 fs-4 text-dark">
                        At Ebun Heritage Schools, we believe in nurturing not just
                        academically proficient students, but also well-rounded individuals
                        who are prepared to make a positive impact in the world. Our
                        dedicated faculty and staff are committed to providing a supportive
                        and enriching environment where every student can thrive and reach
                        their full potential. We invite you to join our community and
                        experience the Ebun Heritage difference.
                    </p>
                    <div className="fs-4 fw-semibold text-dark">
                        Mrs. Omiwale Aderinola
                    </div>
                    <div className="text-muted">
                        Director, Ebun Heritage Schools
                    </div>
                </div>
                </div>
            </div>
        </div>
    </section>

    <section className="py-8 bg-white">
        <div className="container text-center">
            <div className="fs-2 fw-semibold mb-2">
                Our <u class="text-primary"><span class="text-dark">Facilities</span></u>
            </div>
            <p className="mb-6">
                Explore our state-of-the-art facilities designed to foster learning,
                creativity, and growth.
            </p>
            
            <div className="row align-items-center g-4">

        {/* Advanced LMS System */}
        <div className="col-md-4">
            <div className="card shadow-none border-2 border-dark text-center" style={{ borderRadius: "15px" }}>
            <div className="card-body px-0 py-0 text-start">
                <div className="px-5 pt-3 pb-4">
                <span className="iconify" data-icon="mdi:view-dashboard-outline" data-width="35" data-height="35"></span>
                <div className="fs-3 text-dark fw-semibold mt-3 mb-2">Advanced LMS System</div>
                <p className="card-text">Streamlined operations for efficient school administration.</p>
                </div>
                <div className="border-0">
                <img src="../../assets/images/background/lms.png" alt="LMS" className="img-fluid" style={{ height: "150px", width: "100%", objectFit: "cover" }} />
                </div>
            </div>
            </div>
        </div>

        {/* Modern Classrooms */}
        <div className="col-md-4">
            <div className="card shadow-none border-2 border-dark text-center" style={{ borderRadius: "15px" }}>
            <div className="card-body px-0 py-0 text-start">
                <div className="px-5 pt-3 pb-4">
                <span className="iconify" data-icon="mdi:account-group-outline" data-width="35" data-height="35"></span>
                <div className="fs-3 text-dark fw-semibold mt-3 mb-2">Modern Classrooms</div>
                <p className="card-text">Equipped with the latest technology to enhance learning.</p>
                </div>
                <div className="border-0">
                <img src="../../assets/images/background/classroom.png" alt="Classrooms" className="img-fluid" style={{ height: "150px", width: "100%", objectFit: "cover" }} />
                </div>
            </div>
            </div>
        </div>

        {/* Science Labs */}
        <div className="col-md-4">
            <div className="card shadow-none border-2 border-dark text-center" style={{ borderRadius: "15px" }}>
            <div className="card-body px-0 py-0 text-start">
                <div className="px-5 pt-3 pb-4">
                <span className="iconify" data-icon="mdi:microscope" data-width="35" data-height="35"></span>
                <div className="fs-3 text-dark fw-semibold mt-3 mb-2">Science Labs</div>
                <p className="card-text">State-of-the-art labs for hands-on scientific exploration.</p>
                </div>
                <div className="border-0">
                <img src="../../assets/images/background/lab.png" alt="Science Labs" className="img-fluid" style={{ height: "150px", width: "100%", objectFit: "cover" }} />
                </div>
            </div>
            </div>
        </div>

        {/* Large Play Ground */}
        <div className="col-md-4">
            <div className="card shadow-none border-2 border-dark text-center" style={{ borderRadius: "15px" }}>
            <div className="card-body px-0 py-0 text-start">
                <div className="px-5 pt-3 pb-4">
                <span className="iconify" data-icon="mdi:soccer-field" data-width="35" data-height="35"></span>
                <div className="fs-3 text-dark fw-semibold mt-3 mb-2">Large Play Ground</div>
                <p className="card-text">Spacious outdoor area for sports and recreational activities.</p>
                </div>
                <div className="border-0">
                <img src="../../assets/images/background/play.png" alt="Playground" className="img-fluid" style={{ height: "150px", width: "100%", objectFit: "cover" }} />
                </div>
            </div>
            </div>
        </div>

        {/* ICT Room */}
        <div className="col-md-4">
            <div className="card shadow-none border-2 border-dark text-center" style={{ borderRadius: "15px" }}>
            <div className="card-body px-0 py-0 text-start">
                <div className="px-5 pt-3 pb-4">
                <span className="iconify" data-icon="mdi:desktop-mac" data-width="35" data-height="35"></span>
                <div className="fs-3 text-dark fw-semibold mt-3 mb-2">Well Equipped ICT Room</div>
                <p className="card-text">Cutting-edge computers and software for digital literacy.</p>
                </div>
                <div className="border-0">
                <img src="../../assets/images/background/ict.png" alt="ICT Room" className="img-fluid" style={{ height: "150px", width: "100%", objectFit: "cover" }} />
                </div>
            </div>
            </div>
        </div>

        {/* School Bus Service */}
        <div className="col-md-4">
            <div className="card shadow-none border-2 border-dark text-center" style={{ borderRadius: "15px" }}>
            <div className="card-body px-0 py-0 text-start">
                <div className="px-5 pt-3 pb-4">
                <span className="iconify" data-icon="mdi:bus-school" data-width="35" data-height="35"></span>
                <div className="fs-3 text-dark fw-semibold mt-3 mb-2">School Bus Service</div>
                <p className="card-text">Safe and reliable transportation for students.</p>
                </div>
                <div className="border-0">
                <img src="../../assets/images/background/bus.png" alt="School Bus" className="img-fluid" style={{ height: "150px", width: "100%", objectFit: "cover" }} />
                </div>
            </div>
            </div>
        </div>

        {/* Security */}
        <div className="col-md-4">
            <div className="card shadow-none border-2 border-dark text-center" style={{ borderRadius: "15px" }}>
            <div className="card-body px-0 py-0 text-start">
                <div className="px-5 pt-3 pb-4">
                <span className="iconify" data-icon="mdi:shield-lock-outline" data-width="35" data-height="35"></span>
                <div className="fs-3 text-dark fw-semibold mt-3 mb-2">Multi-Layer Security</div>
                <p className="card-text">Ensuring a safe and secure environment for all students.</p>
                </div>
                <div className="border-0">
                <img src="../../assets/images/background/secure.png" alt="Security" className="img-fluid" style={{ height: "150px", width: "100%", objectFit: "cover" }} />
                </div>
            </div>
            </div>
        </div>

        {/* Book & Library */}
        <div className="col-md-4">
            <div className="card shadow-none border-2 border-dark text-center" style={{ borderRadius: "15px" }}>
            <div className="card-body px-0 py-0 text-start">
                <div className="px-5 pt-3 pb-4">
                <span className="iconify" data-icon="mdi:bookshelf" data-width="35" data-height="35"></span>
                <div className="fs-3 text-dark fw-semibold mt-3 mb-2">Book & Library</div>
                <p className="card-text">A vast collection of resources to support learning and research.</p>
                </div>
                <div className="border-0">
                <img src="../../assets/images/background/lib.png" alt="Library" className="img-fluid" style={{ height: "150px", width: "100%", objectFit: "cover" }} />
                </div>
            </div>
            </div>
        </div>

        {/* Guidance & Counselling */}
        <div className="col-md-4">
            <div className="card shadow-none border-2 border-dark text-center" style={{ borderRadius: "15px" }}>
            <div className="card-body px-0 py-0 text-start">
                <div className="px-5 pt-3 pb-4">
                <span className="iconify" data-icon="mdi:account-tie-outline" data-width="35" data-height="35"></span>
                <div className="fs-3 text-dark fw-semibold mt-3 mb-2">Guidance & Counselling</div>
                <p className="card-text">Supporting students' emotional and academic well-being.</p>
                </div>
                <div className="border-0">
                <img src="../../assets/images/background/support.png" alt="Counselling" className="img-fluid" style={{ height: "150px", width: "100%", objectFit: "cover" }} />
                </div>
            </div>
            </div>
        </div>

        </div>

        </div>
    </section>

    <section className="py-8 bg-light">
        <div className="container text-center">
            <div className="row">
                
                <div className="col-md-5">
                    <div className="text-center text-md-start px-0 px-md-10">
                        <div className="text-muted text-uppercase mb-2 fs-6">Special Programs</div>
                        <div className="fs-m fw-semibold mb-2 text-dark">
                        Nurturing Values Fostering Community
                        </div>
                        
                    </div>
                    <div className="mt-4 text-justify text-md-start px-0 px-md-10">
                        <p className="mb-4 fs-6 text-dark">
                            At Ebun Heritage Schools, we believe in nurturing not just
                            academically proficient students, but also well-rounded individuals
                            who are prepared to make a positive impact in the world. 
                            <br/><br/>
                            Our
                            dedicated faculty and staff are committed to providing a supportive
                            and enriching environment where every student can thrive and reach
                            their full potential. We invite you to join our community and
                            experience the Ebun Heritage difference.
                        </p>
                    </div>
                </div>

                <div className="col-md-7 mt-6 mt-md-0">
                
                  <div className="">
                  <Swiper
                    modules={[Pagination]}
                    spaceBetween={10}
                    slidesPerView={isMobile ? 2 : 3}
                    pagination={{ clickable: true }}
                    breakpoints={{
                        640: { slidesPerView: 2 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                      }}
                    centeredSlides={true}
                    initialSlide={2} // 👈 starts at the 3rd slide (index is 0-based)
                    onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
                    style={isMobile ? { paddingBottom: "40px", paddingRight: '80px'} : { paddingBottom: "40px"}} // Extra space for pagination
                    >
                    {events.map((event, index) => (
                        <SwiperSlide key={index}>
                        <div
                            className="card px-0 py-4 text-start border-0 bg-white"
                            style={getCardStyle(index)}
                        >
                            <div className="p-4">
                            <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg" 
                            class="text-pastels-yellow" style={{ color: '#4EC3F7'}}>
                            <path d="M20 0s-.834 17.324-20 20c0 0 16.453.315 20 20 0 0 1.13-17.018 20-20 0 0-17.93-2.523-20-20Z" 
                            fill="currentColor"></path></svg>
                            <div className="fs-3 fw-semibold text-dark mb-2">
                                {event.title}
                            </div>
                            <div className="fs-6 mb-0 text-dark">{event.description}</div>
                            </div>
                        </div>
                        </SwiperSlide>
                    ))}
                  </Swiper>
                  </div>

                </div>

            </div>
        </div>
    </section>

    <section
    className="py-10 bg-white position-relative"
    style={{
        backgroundImage: "url('../../assets/images/background/illust.svg')",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "calc(100% + 105px) calc(100% + 10px)", 
        backgroundSize: "400px auto",
      }}      
    >
    <div className="container-fluid text-center">
        <div className="text-center text-lg-center mb-6 px-lg-6">
        <div className="fs-2 fw-semibold mb-2">
        <u className="text-primary">
            <span className="text-dark">Enrollment</span>
        </u>{" "}
        Now Made Easy
        </div>
        <p className="mb-6">
        Explore our state-of-the-art facilities designed to foster learning,
        creativity, and growth.
        </p>
        </div>
        <div className="row py-lg-4 py-4 mb-lg-20">
        {/* your content here */}

        <div className="col-md-5 mb-6 mb-md-0">
            <div className="text-center text-lg-start px-0 px-lg-6">
               <img src="../../assets/images/background/enroll.svg" alt="Enroll" className="img-fluid" />
            </div>
        </div>

        <div className="col-md-7 mt-4 mt-md-0 px-2 px-lg-10 mb-20 mb-md-0">
            <SmartAi/>
        </div>

        </div>
    </div>
    </section>


    <section className="py-5 bg-light position-relative">
        <div className="container-fluid text-center">

            <div className="px-0 px-lg-12 mb-lg-6 mb-12">
            <div className="card testimony-bg shadow-none border-0 bg-dark-blue 
            px-lg-4 py-lg-6 py-2 mt-n20" style={{ borderRadius: "60px" }}>
                <div className="row justify-content-center">
                    <div className="col-lg-5 mb-6 mb-lg-0 px-4 px-lg-8">
                        
                    </div>
                    <div className="col-lg-7 text-center text-lg-start px-6 px-lg-8">
                        <div className="fs-2 mb-lg-4 mb-6 text-white fw-medium">
                        <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg" 
                            class="text-pastels-yellow" style={{ color: '#4EC3F7'}}>
                            <path d="M20 0s-.834 17.324-20 20c0 0 16.453.315 20 20 0 0 1.13-17.018 20-20 0 0-17.93-2.523-20-20Z" 
                            fill="currentColor"></path></svg> {" "}
                            Testimonials
                        </div>

                        <div className="swiper-container text-start">

                        <Swiper
                            modules={[Pagination, Autoplay]}
                            spaceBetween={30} 
                            slidesPerView={1}
                            autoplay={{ delay: 5000 }} // Autoplay every 5 seconds
                            breakpoints={{
                                640: { slidesPerView: 1 },
                                768: { slidesPerView: 1 },
                                1024: { slidesPerView: 1 },
                              }}
                            >
                            {testimonials.map((testimonial, index) => (
                                <SwiperSlide key={index}>
                                    <div className="mb-4">
                                        <div className="mb-6 fs-5 text-white">
                                            "{testimonial.feedback}"
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <img
                                                src={testimonial.avatar}
                                                alt={testimonial.name}
                                                className="rounded-circle me-3" 
                                                style={{ width: "150px", height: "150px", objectFit: "cover" }}
                                            />
                                            <div className="text-white">
                                                <div className="fw-medium">{testimonial.name}</div>
                                                <div className="text-muted">{testimonial.role}</div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>   

                        </div>
                        
                    </div>
                </div>
            </div>
            </div>
        </div>
    </section>

    <Core/>

    <Footer/>

    </main>
    </>
  )
}

export default Home